import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.156 3A5.855 5.855 0 0 0 12 6.05 5.855 5.855 0 0 0 6.844 3C3.617 3 1 5.582 1 8.765c0 .114.003.227.01.34H1c0 7.46 9.823 12.607 9.823 12.607.322.193.744.288 1.169.288.429 0 .858-.098 1.185-.288 0 0 9.823-5.146 9.823-12.607h-.01c.007-.113.01-.226.01-.34C23 5.582 20.383 3 17.156 3z"
});

var SvgLikeFilled = function SvgLikeFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgLikeFilled;